import { type TFunction } from "i18next";
import { notifications } from "@mantine/notifications";

export const failureDuringRewardCollection = (
  t: TFunction,
): void => {
  notifications.show({
    message: t('during_reward_collection'),
    title: t('something_went_wrong'),
    color: 'red',
  });
};
